import axios from "axios";
import {
  NFC_INFO_URL, NFC_TUTAR_INFO_URL, NFC_TAHSILAT_HAZIRLA_URL, NFC_YUKLEME_KAYDET_URL
} from "./constants";
import {NfcCardInfo} from "../ebelediye/entities/NfcCardInfo";

class NfcService {
  getNfcInfo(aboneNo: string, sayacNo: string, cardSeriNo: string) {
    const url = `${NFC_INFO_URL}/${aboneNo}/${sayacNo}/${cardSeriNo}`;
    console.log('NFC_INFO_URL: ', url);
    return axios
      .post(url)
      .then((res) => res.data);
  }

  getAmountInfo(aboneNo: string, tonAmount: number) {
    return axios
      .post(`${NFC_TUTAR_INFO_URL}/${aboneNo}/${tonAmount}`)
      .then((res) => res.data);
  }

  tahsilatHazirla(aboneNo: string, tutar: number) {
    return axios
      .post(
        NFC_TAHSILAT_HAZIRLA_URL,
        { tcNo: aboneNo, genelToplam: tutar }
      )
      .then((res) => res.data);
  }

  yuklemeKaydet(nfcCardInfo: NfcCardInfo | undefined, referansNo: string | undefined) {
    return axios
      .post(
        `${NFC_YUKLEME_KAYDET_URL}/${referansNo}`,
        nfcCardInfo
      )
      .then((res) => res.data);
  }
}

const nfcService = new NfcService();
export default nfcService;
